import * as HttpService from "../../../../service/HttpService";


/**
 *查询空调经济模型列表
 */
export const queryReportForm = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/defectiveWorkOrder/queryReportForm", params);
};

/**
 * 查询管控收益报表
 */
export const queryProfitData = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/esMgmtOutPlanEventStat/queryProfitData", params);
};
export const queryTree = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/realTimeMonitoring/queryTree", params);
};
